/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListMutes.defs.js'
export * as $defs from './getListMutes.defs.js'
